/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import {Loader} from '../../Helpers/Helpers';

export default class FrameItems extends Component {

	constructor(props, context) {
		super(props, context);
		this.removeFrame = this.removeFrame.bind(this);
	}

	selectFrame = (frameProduct) => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedFrame: frameProduct,
				frameLoading: false
			}
		})
		const { selectedStretching, stretching } = this.props;
		if (selectedStretching.getIn(['title', 'rendered']) === 'Un Stretched') {
			stretching.filter( ( stretch ) =>
				'Stretched' === stretch.getIn(['title', 'rendered'])
			).map( ( stretch ) =>
				this.props.dispatch({
					type: 'SET_STATE',
					state: {
						selectedStretching: stretch
					}
				})
			)
		}
	};

	removeFrame() {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedFrame: [],
				canvasFrameTotal: 0
			}
		})
	}

	render() {
		const {frameProducts, displayCategory, selectedFrame, productsLaoded} = this.props;
	    return (
	    	<div className="frm_mn_box">
				{productsLaoded ?
					<div className="row">
						<div className="col-sm-12">
							{selectedFrame.size > 0 &&
								<a href="#!" onClick={this.removeFrame} className="btn btn-danger text-upper" style={{ marginBottom: 15 }}>Remove Frame</a>
							}
							<div className="row">
								{frameProducts.filter( ( frameProduct ) =>
									frameProduct.get('categories').some( ( categories ) =>
										displayCategory === categories.get('id')
									)).map( (frameProduct) =>
										<div className="col-sm-3" key={frameProduct.get('id')} style={{ cursor: 'pointer' }} onClick={this.selectFrame.bind(this, frameProduct)}>
											<strong style={{ marginBottom: 10, display: 'block', color: '#000'}}>{frameProduct.get('name')}</strong>
											<img src={frameProduct.getIn(['images', 0, 'src'])} alt={frameProduct.get('name')} className={selectedFrame.get('id') === frameProduct.get('id') ? "selectedImageFrameNew" : ''} />
										</div>
									)
								}
							</div>
						</div>
					</div>
    		 	: <Loader/>
    			}
		    </div>
	    );
	}
}